import { combineAuth } from './hr-authority';
import {HrCommonAuthority} from "./hr-common-authority";

export class HrCommonReadableAuthority extends HrCommonAuthority{

    public static readonly READ = "read";

    constructor(authority: string) {
        super(authority);
        this.READ = combineAuth(this.BASE, HrCommonReadableAuthority.READ);
    }

    public readonly READ: string;
}
